import api from "./apiV1";

export const getCustomerUnitsAreas = () => {
  return api.get("customer-units");
};
